import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from '../remote/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  let authService = inject(AuthService);
  const authToken = authService.getTokenFromLocalStorage();
  if (authToken) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return next(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return handle401Error(clonedRequest, next, authService);
        }
        return throwError(() => error);
      })
    );
  }
  return next(req);
};

function handle401Error(
  request: HttpRequest<any>,
  next: HttpHandlerFn,
  authService: AuthService
): Observable<HttpEvent<any>> {
  return authService.refreshToken().pipe(
    switchMap((response: any) => {
      const newToken = response.access_token;
      const newRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${newToken}`,
        },
      });
      return next(newRequest);
    }),
    catchError((err) => {
      authService.logout();
      return throwError(() => err);
    })
  );
}
